var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container fixed-bottom",on:{"click":_vm.logout}},[_c('div',{staticClass:"icon_footer_logout"}),_vm._v(" "),_c('div',{},[_vm._v("ログアウト")])])}
var staticRenderFns = []

export { render, staticRenderFns }